// This file was generated by svgr, do not edit it.
import * as React from 'react'
import { clsx } from 'clsx'
import styles from '../Icon.module.css'
import {
  computeStrokeWidth,
  computeSize,
  getIconColorClassName,
} from '../helpers'
import type { IconProps, IconComponentRef } from '../helpers'
const NoteDotIcon = React.forwardRef(
  (
    { size, stroke, className, color, ...props }: IconProps,
    ref: IconComponentRef,
  ) => {
    const iconName = 'note-dot'
    const computedSize = computeSize(size)
    const computedStrokeWidth = computeStrokeWidth(computedSize, stroke)
    return (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={clsx(className, styles.base, getIconColorClassName(color))}
        data-icon={iconName}
        aria-hidden="true"
        strokeWidth={computedStrokeWidth}
        width={computedSize}
        height={computedSize}
        ref={ref}
        {...props}
      >
        <path
          d="M20.5 12V19C20.5 19.5304 20.2893 20.0391 19.9142 20.4142C19.5391 20.7893 19.0304 21 18.5 21L8.50001 21C8.18311 21.0008 7.86921 20.9388 7.5764 20.8176C7.28359 20.6964 7.01768 20.5185 6.79401 20.294L3.20601 16.706C2.98153 16.4823 2.80357 16.2164 2.68239 15.9236C2.56122 15.6308 2.49923 15.3169 2.50001 15L2.50001 5C2.50001 4.46957 2.71072 3.96086 3.0858 3.58579C3.46087 3.21072 3.96958 3 4.50001 3H11.5M9.5 21L9.5 15.1667C9.5 14.8572 9.37708 14.5605 9.15829 14.3417C8.9395 14.1229 8.64275 14 8.33333 14H2.5M21 5.75C21 7.26878 19.7688 8.5 18.25 8.5C16.7312 8.5 15.5 7.26878 15.5 5.75C15.5 4.23122 16.7312 3 18.25 3C19.7688 3 21 4.23122 21 5.75Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
)
NoteDotIcon.displayName = 'NoteDotIcon'
export { NoteDotIcon }
